import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';

import type { OrgUnitSimple } from 'src/types/orgUnit';
import type { SurveyListItem } from 'src/types/survey';
import OverdueActionItemsBell from 'src/components/survey/components/OverdueActionItemsBell';
import { useSurveyList } from 'src/components/survey/SurveyContext/ListContext';

import { styles } from './WidgetTileHeader.styles';

interface WidgetTileHeaderProps {
  survey: SurveyListItem;
  orgUnit?: OrgUnitSimple;
}

const WidgetTileHeader: FC<WidgetTileHeaderProps> = ({ survey, orgUnit }) => {
  const { t } = useTranslation('survey');
  const { selectSurvey } = useSurveyList();
  const handleOpenSurvey = () => selectSurvey(survey.id);

  return (
    <Stack
      direction="column"
      spacing={0.5}
      sx={{
        pt: 2,
        px: 2.75,
      }}
    >
      <Stack
        direction="row-reverse"
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <OverdueActionItemsBell count={survey.overdueActionItemCount} />
        <Button onClick={handleOpenSurvey}>{t('goToSurvey')}</Button>
        {/* Hide FollowUpAction button for now */}
        {/* <WidgetFollowUpAction /> */}
      </Stack>
      <Typography variant="h5" component="h3">
        {survey.name}
      </Typography>
      {orgUnit ? (
        <Stack direction="row" spacing={1}>
          <Typography variant="h6" sx={styles.subline}>
            {orgUnit.name}
          </Typography>
          <Typography sx={styles.sublineSuffix}>
            #{orgUnit.orgUnitId}
          </Typography>
        </Stack>
      ) : (
        <Typography variant="h6" sx={styles.subline}>
          -
        </Typography>
      )}
    </Stack>
  );
};

export default WidgetTileHeader;
